import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HanselMaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeepConfigDialogComponent } from './datasource/deep-config-dialog/deep-config-dialog.component';
import { ModuleDialogComponent } from './datasource/module-dialog/module-dialog.component';
import { SelectModuleDialogComponent } from './datasource/select-module-dialog/select-module-dialog.component';
import { CreateActionDialogComponent } from './datasource/create-action-dialog/create-action-dialog.component';
import { CbCheckoutDialogComponent } from './settings/company-settings/billing/cb-checkout-dialog/cb-checkout-dialog.component';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpConfigInterceptor } from './core/services/httpconfig.interceptor';
import { HeaderService } from './core/header/header.service';
import { CustomMaterialComponentsModule } from './custom-material-components/custom-material-components.module';
// import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { SharedModule } from './shared/shared.module';
import { AnalyticsDialogComponent } from './product-journey-manager/analytics-dialog/analytics-dialog.component';
import { NgChartsModule } from 'ng2-charts';
import { CookieService } from 'ngx-cookie-service';
import { PromptsAnalyticsDialogComponent } from './product-journey-manager/prompts-analytics-dialog/prompts-analytics-dialog.component';
import { AddUserComponent } from 'src/app/user-management/add-user/add-user.component';
import { JsonViewDialogComponent } from 'src/app/datasource/json-view-dialog/json-view-dialog.component';
import { AceEditorModule } from 'ngx-ace-editor-wrapper';

@NgModule({
  declarations: [
    AppComponent,
    DeepConfigDialogComponent,
    ModuleDialogComponent,
    SelectModuleDialogComponent,
    CreateActionDialogComponent,
    AnalyticsDialogComponent,
    PromptsAnalyticsDialogComponent,
    AddUserComponent,
    // PerfectScrollbarComponent,
    JsonViewDialogComponent,
    CbCheckoutDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HanselMaterialModule,
    CustomMaterialComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    IconSpriteModule,
    CoreModule,
    HttpClientModule,
    SharedModule,
    NgChartsModule,
    AceEditorModule,
    // Angular2PromiseButtonModule
    //   .forRoot({
    //     // the class used to indicate a pending promise
    //     btnLoadingClass: 'btn-loader',
    //     // only disable and show is-loading class for clicked button,
    //     // even when they share the same promise
    //     handleCurrentBtnOnly: false
    //   }),
  ],
  providers: [
    HeaderService,
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
